import apisauce from "apisauce"
import history from "./History"
import dotenv from "dotenv"
dotenv.config()

// Local
//const baseURL = `http://ec2-54-146-222-41.compute-1.amazonaws.com:3000/admin/`

// Dev

const RestAPI = () => {
	const baseURL = process.env.REACT_APP_API_URL
	const apiUpload = apisauce.create({
		baseURL,
		headers: {
			"Content-Type": "multipart/form-data",
		},
		timeout: 30000,
	})
	const api = apisauce.create({
		baseURL,
		headers: {
			"Cache-Control": "no-cache",
			"Content-Type": "application/json",
		},
		timeout: 30000,
	})

	const naviMonitor = (response) => console.log("========== API Response ==========", response)
	api.addMonitor(naviMonitor)
	apiUpload.addMonitor(naviMonitor)

	api.addResponseTransform((response) => {
		if (response.status === 401) history.push("/login")
	})

	let sessionToken = sessionStorage.getItem("accessToken")
	if (sessionToken) {
		api.setHeader("accesstoken", sessionToken)
		apiUpload.setHeader("accesstoken", sessionToken)
	}

	// Access Token
	const setAccessToken = (token) => {
		api.setHeader("accesstoken", token)
	}

	const clearAccessToken = (token) => {
		sessionStorage.removeItem("accessToken")
		api.deleteHeader("accesstoken")
	}

	const getOrders = () => api.get("orders")
	const getDownloads = (data) => api.post("downloads", data)

	const createOrder = (data) => api.post("orders", data)
	const uploadOrders = (data) => api.post("ordersUpload", data)
	const findOrder = (data) => api.post("findOrder", data)
	const updateOrderDownloads = (data) => api.patch("orderDownloads", data)
	const updateOrderExpiration = (data) => api.patch("orderExpiration", data)
	const deleteOrder = (data) => api.delete(`orders/${data}`, data)

	const getProducts = () => api.get("products")
	const getProduct = (id) => api.get(`products/${id}`)
	const findProduct = (data) => api.get(`findProduct/${data}`)
	const createProduct = (data) => api.post("products", data)
	const updateProduct = (data) => api.patch("products", data)
	const deleteProduct = (data) => api.delete(`products/${data}`, data)
	const fileExists = (data) => api.get(`products/fileexists/${data}`)
	const uploadChunk = (formData) => apiUpload.post(`uploadchunk`, formData)
	const finishUpload = (data) => api.post(`uploadfinish`, data)
	// const initUpload = (data) => api.post('upload', data)
	// const uploadChunk = (partNumber, uploadId, data) => api.put(`upload?partNumber=${partNumber}&uploadId=${uploadId}`, data)
	// const completeUpload = (data) => api.post('upload/complete',data);

	return {
		setAccessToken,
		clearAccessToken,
		getOrders,
		getDownloads,
		createOrder,
		uploadOrders,
		findOrder,
		updateOrderDownloads,
		updateOrderExpiration,
		deleteOrder,
		getProducts,
		getProduct,
		findProduct,
		createProduct,
		updateProduct,
		deleteProduct,
		fileExists,
		uploadChunk,
		finishUpload,
		// initUpload,
		// uploadChunk,
		// completeUpload
	}
}

export const API = RestAPI()
